import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Paper, Typography } from "@mui/material";

import Logo from "../../vendor/tiehoitokunta_logo_transparent.png";
import ResetPasswordComponent from "../../components/auth/ResetPassword";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function ResetPassword() {
  return (
    <React.Fragment>
      <img
        src={Logo}
        alt="tiehoitokunta_logo"
        style={{ width: "150px", height: "150px" }}
      />
      <Wrapper>
        <Helmet title="Reset Password" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Unohtunut salasana
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Syötä sähköpostiosoitteesi palauttaaksesi salasanasi
        </Typography>

        <ResetPasswordComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default ResetPassword;
